var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "First Date Timezone" },
          model: {
            value: _vm.clone.isBefore.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBefore, "fromTimezone", $$v)
            },
            expression: "clone.isBefore.fromTimezone",
          },
        }),
        _vm._v(" "),
        _c("TimezonePickerInput", {
          attrs: { title: "Second Date Timezone" },
          model: {
            value: _vm.clone.isBefore.toTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBefore, "toTimezone", $$v)
            },
            expression: "clone.isBefore.toTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "First Date Format" },
          model: {
            value: _vm.clone.isBefore.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBefore, "fromFormat", $$v)
            },
            expression: "clone.isBefore.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "Second Date Format" },
          model: {
            value: _vm.clone.isBefore.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBefore, "toFormat", $$v)
            },
            expression: "clone.isBefore.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "First Date Locale" },
          model: {
            value: _vm.clone.isBefore.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBefore, "fromLocale", $$v)
            },
            expression: "clone.isBefore.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "Second Date Locale" },
          model: {
            value: _vm.clone.isBefore.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBefore, "toLocale", $$v)
            },
            expression: "clone.isBefore.toLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }